import {AfterViewInit, Component, OnInit, ViewChild} from '@angular/core';
import { Router} from "@angular/router";
import { HybridToolsService } from '../../core/services/hybrid-tools.service';
import {NationalTeamsService} from '../../core/services/national-teams.service';
import {DatagridComponent} from '../../ui/datagrid/datagrid.component';
import {PageService} from '../../core/services/page.service';
import {CurrencyPipe} from '@angular/common';
import {EditTeamComponent} from '../../core/components/dialogs/edit-team/edit-team.component';
import {NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {ProgressService} from "../../core/services/progress.service";
import {ToastrService} from "ngx-toastr";
import {TeamService} from '../../core/services/team.service';

import * as moment from 'moment';
import {TotalRaisedDialogComponent} from "../../core/components/dialogs/total-raised-dialog/total-raised-dialog.component";
declare var $: any;

@Component({
    selector: 'national-team',
    templateUrl: './national-team.component.html',
    styles: [`
      .national-team-page {
        margin: 0 0 1.35rem 0;
      }
      .national-team-page .page-actions .btn {
          margin-left: 0.5rem !important;
      }
    `]
})

export class NationalTeamComponent implements OnInit, AfterViewInit {

    @ViewChild('teamsTable', { static: true })
    teamsTableInstance: DatagridComponent;

    public teamsGridOptions: any;

    constructor(
                public modalService: NgbModal,
                public pageService: PageService,
                public nationalTeamsService: NationalTeamsService,
                public hybridToolsService: HybridToolsService,
                private router: Router,
                private cp: CurrencyPipe,
                private ToastrService: ToastrService,
                private teamService: TeamService,
                private progressService: ProgressService) {
        this.nationalTeamsService.onNationalTeamInit.subscribe(nationalTeam => {
            if (this.teamsTableInstance) {
                const data = this.nationalTeamsService.selectedNationalTeam.subTeams;
                this.teamsTableInstance.replaceData(data);
                this.showTablePaginator(data);
            }
        });
        this.nationalTeamsService.onNationalTeamChange.subscribe(nationalTeam => {
            if (this.teamsTableInstance) {
                const data = this.nationalTeamsService.selectedNationalTeam.subTeams;
                this.teamsTableInstance.replaceData(data);
                this.showTablePaginator(data);
            }
        });
    }

    ngOnInit() {
        this.setupGrid();
    }

    setupGrid() {
        let teamsData: any;
        teamsData = this.nationalTeamsService.selectedNationalTeam.subTeams;

        let columns: any;

        columns = [
            {
                title: 'Team Name',
                data: 'name',
                width: 200,
            }, {
                title: 'Goal',
                data: 'teamFundraisingGoal',
                width: 85,
                type: 'currency'
            }
            , {
                title: 'Total Raised',
                data: 'total',
                render: (data, type, row) => {
                    return '<a class="ui-total-raised-link text-primary national-team-item" data-total="' + row.total
                                + '" data-donationsreceived="' + row.donationsReceived
                                + '" data-promises="' + row.outstandingMatchingGifts
                                + '" data-sponsorships="' + row.outstandingSponsorships + '">'
                                + this.cp.transform(row.total, 'USD', true)
                            + '</a>';
                },
                width: 85,
                type: 'currency'
            }, {
                title: 'Team Total',
                data: 'donationsReceived',
                width: 90,
                visible: false,
                type: 'currency'
            }, {
                title: 'Sponsorship',
                data: 'outstandingSponsorships',
                width: 85,
                visible: false,
                type: 'currency'
            }, {
                title: 'Captain',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 0) {
                        return row.captains[0].captainName;
                    } else {
                        return '';
                    }
                },
                class: 'excludeExport',
                width: 150
            }, {
                title: 'Office',
                data: 'chapter',
                width: 150
            }, {
                title: 'Walksite',
                data: 'walkLocation',
                width: 150
            }, {
                title: 'Walk Date',
                data: 'walkDate',
                class: 'date-col',
                render: (x) => {
                    return moment(x).parseZone().format('MM/DD/YYYY');
                },
                width: 90
            }, {
                title: '# of Walkers',
                data: 'numberOfWalkers',
                width: 95,
            }, {
                title: 'Captain 1',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 0) {
                        return row.captains[0].captainName;
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Email 1',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 0) {
                        return row.captains[0].email;
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Phone 1',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 0) {
                        let areaCode = row.captains[0].areaCode;
                        let phoneNumber = row.captains[0].phoneNumber;
                        return (!!areaCode && areaCode.trim() !== '' ? '(' + areaCode + ') ' : '')
                            + ((!!phoneNumber && phoneNumber >= 7) ? (phoneNumber.substring(phoneNumber.length - 7, phoneNumber.length - 4) + '-' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length)): '');
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Captain 2',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 1) {
                        return row.captains[1].captainName;
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Email 2',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 1) {
                        return row.captains[1].email;
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Phone 2',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 1) {
                        let areaCode = row.captains[1].areaCode;
                        let phoneNumber = row.captains[1].phoneNumber;
                        return (!!areaCode && areaCode.trim() !== '' ? '(' + areaCode + ') ' : '')
                            + ((!!phoneNumber && phoneNumber >= 7) ? (phoneNumber.substring(phoneNumber.length - 7, phoneNumber.length - 4) + '-' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length)): '');
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Captain 3',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 2) {
                        return row.captains[2].captainName;
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Email 3',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 2) {
                        return row.captains[2].email;
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Phone 3',
                render: (data, type, row) => {
                    if(row.captains && row.captains.length > 2) {
                        let areaCode = row.captains[2].areaCode;
                        let phoneNumber = row.captains[2].phoneNumber;
                        return (!!areaCode && areaCode.trim() !== '' ? '(' + areaCode + ') ' : '')
                            + ((!!phoneNumber && phoneNumber >= 7) ? (phoneNumber.substring(phoneNumber.length - 7, phoneNumber.length - 4) + '-' + phoneNumber.substring(phoneNumber.length - 4, phoneNumber.length)): '');
                    } else {
                        return '';
                    }
                },
                className: 'none'
            }, {
                title: 'Parent Team Name',
                data: 'parentTeamName',
                width: 95,
                className: 'none'
            }
            , {
                className: 'control',
                sortable: false,
                title: 'Show More',
                width: 90,
                render: (x) => {
                    return '';
                },
                responsivePriority: 3,
                class: 'control excludeExport'
            }
        ];

        this.teamsGridOptions = {
            // ajax: 'data/data.json',
            data: teamsData,
            order: [[ 2, 'desc' ]],
            responsive: {
                details: {
                    type: 'column',
                    target: -1
                }
            },
            columns: columns,
            initComplete: function() {
                // Nothing needed here yet.
            }
        };

    }

    showTablePaginator(data) {
        if (data.length < 10) {
            $('.dataTables_paginate ').hide();
        } else {
            $('.dataTables_paginate ').show();
        }
    }

    currentNationalTeamName() {
        return this.nationalTeamsService.selectedNationalTeam.name;
    }

    openchangeTeamModal() {
        let modal = this.modalService.open(EditTeamComponent);
        modal.result.then(result => {
            if (result) {
                this.progressService.startProgress(false);
                this.teamService.saveTeamEdit(this.nationalTeamsService.selectedNationalTeam.teamId, {
                    name: this.nationalTeamsService.selectedNationalTeam.name,
                    imageID: result.constituentImageLibraryId
                }).subscribe(() => {
                    this.ToastrService.success("Team updated successfully.");
                    this.progressService.stopProgress(false);
                }, err => {
                    this.ToastrService.error("Error happened during update.");
                    this.progressService.stopProgress(false);
                });
                this.nationalTeamsService.selectedNationalTeam.imagePath = result.imagePath;
            }
        }, () => {/* avoids error on 'cancel' */});
    }

    ngAfterViewInit(): void {
        if(this.teamsTableInstance) {
            this.teamsTableInstance.bindClick('.national-team-item', (event) => {
                var data = event.target.dataset;
                this.openTotalRaisedModal(data.total, data.donationsreceived, data.promises, data.sponsorships);
            });
        }
    }

    openTotalRaisedModal(totalRaised, donationRecieved, promises, sponsorships) {
        const totalRaisedModal = this.modalService.open(TotalRaisedDialogComponent);
        totalRaisedModal.componentInstance.totalRaised = totalRaised;
        totalRaisedModal.componentInstance.donationsReceived = donationRecieved;
        totalRaisedModal.componentInstance.promises = promises;
        totalRaisedModal.componentInstance.sponsorships = sponsorships;
        totalRaisedModal.componentInstance.isNationalTeam = true;
    }
}

